<template>
  <nna-container :spacing=10>
    <div class="services-checkout">
      <h1 class="md-title text-align-left">Riepilogo ordine</h1>
      <div class="">        
        <div v-for="services in cart" :key="services.oid" class="product p-3 text-align-left">
          <div class="pb-2"><strong>{{services.pieces}}x {{services.name}}</strong></div>
          <div class="pb-2">
            <span>Data:</span> <span>{{reservationDate}}</span>
          </div>
          <div v-for="opt in services.options" :key="opt.oid" v-if="opt.number > 0">            
            <span>{{opt.number}}x</span> <span>{{opt.name}}</span>
          </div>
          <!--<div class="pt-2">
            <span>Postazione:</span> 
            <div>Fila 3 | Ombrellore n° 38</div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="checkout">
      <div class="cart__total md-layout md-gutter mt-4 m-3">
        <div class="md-layout-item text-align-left">
          <div class="cart__totalLabel">Totale</div>
        </div>
        <div class="md-layout-item text-align-right">
          <div class="cart__totalSum">€{{total}}</div>
        </div>
      </div>
      <nna-action-footer>
        <nna-button v-if="isAuthenticated" @click.native="$router.push({ name: 'services.checkout' })">Conferma Prenotazione</nna-button>
        <nna-button v-else @click.native="$router.push({ name: 'services.checkout' })">Accedi per prenotare</nna-button>        
      </nna-action-footer>
    </div>
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ServicesOrderSummary',
  components: {  
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart',
      total: 'cart/servicesTotal',
      reservationDate: 'global/reservationDate',
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    ...mapActions({}),    
  },
  mounted() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.services-checkout {
  .md-title {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/ServicesOrderSummary.vue